module.exports = __webpack_public_path__ + "img/pic_18.ee2e0600.jpg";